import { apiFetch } from "@/api/client";
import { ep } from "@/api/endpoints";
import type { PhotoUrlRequest, PhotoUrlResponse } from "@/api/types";
import { resizeImage } from "@/lib/resizeImage";

/** presigned PUT. 인증 헤더 없이 절대 URL 로 보내야 하므로 apiFetch 를 거치지 않고, 진행률을 위해 XMLHttpRequest 를 쓴다. */
function putBlob(url: string, blob: Blob, onProgress?: (ratio: number) => void): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", url);
    xhr.setRequestHeader("Content-Type", blob.type);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress?.(e.loaded / e.total);
    };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`UPLOAD_${xhr.status}`)));
    xhr.onerror = () => reject(new Error("UPLOAD_NETWORK"));
    xhr.timeout = 60_000;
    xhr.ontimeout = () => reject(new Error("UPLOAD_NETWORK"));
    xhr.send(blob);
  });
}

/** resize → POST /me/photo-url → PUT → photoKey. 이어서 호출부가 PATCH /me {photoKey} 한다. */
export async function uploadAccountPhoto(file: File, onProgress?: (ratio: number) => void): Promise<{ photoKey: string }> {
  const blob = await resizeImage(file);
  const body: PhotoUrlRequest = { contentType: blob.type as PhotoUrlRequest["contentType"], size: blob.size };
  const res = await apiFetch<PhotoUrlResponse>(ep.mePhotoUrl, { method: "POST", body });
  await putBlob(res.uploadUrl, blob, onProgress);
  onProgress?.(1);
  return { photoKey: res.photoKey };
}
